import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
	state:{
		Collapse:false,
		userId:"",
    userName:"",
    memeberId:"",
    memeberName:"",
    reusmeId:"",
    organName:"",
    SiteId:1,
    ADId:1,
    siteInfo:{},
    lightboxInfo:{}
	},
	mutations: {
    changeCollapse (state) {
      state.Collapse=(state.Collapse==false)?true:false;
    },
    setUserId(state,value){
      state.userId=value;
      sessionStorage.setItem("userId", value);
    },
    setUserName(state,value){
      if(value=="") {sessionStorage.removeItem("userName");}
      state.userName=value;
      sessionStorage.setItem("userName", value);
    },
    setMemeberId(state,value){
      if(value=="") {sessionStorage.removeItem("memeberId");}
      state.memeberId=value;
      sessionStorage.setItem("memeberId", value);
    },
    setMemeberName(state,value){
      if(value=="") {sessionStorage.removeItem("memeberName");}
      state.memeberName=value;
      sessionStorage.setItem("memeberName", value);
    },
    setreusmeId(state,value){
      state.reusmeId=value;
    },
    setOrganName(state,value){
      if(value=="") {sessionStorage.removeItem("organName");}
      state.organName=value;
      sessionStorage.setItem("organName", value);
    },
    setSiteId(state,value){
      state.SiteId=value;
      sessionStorage.setItem("SiteId", value);
    },
    setADId(state,value){
      state.ADId=value;
      sessionStorage.setItem("ADId", value);
    },
    setsiteInfo(state,value){
      state.siteInfo=value;
      sessionStorage.setItem("siteInfo", JSON.stringify(value));
    },
    setlightboxInfo(state,value){
      state.lightboxInfo=value;
      sessionStorage.setItem("lightboxInfo", JSON.stringify(value));
    },
    getUserId(state){
      state.userId=sessionStorage.getItem("userId");
    },
    getUserName(state){
      state.userName=sessionStorage.getItem("userName");
    },
    getMemeberId(state){
      state.memeberId=sessionStorage.getItem("memeberId");
    },
    getMemeberName(state){
      state.memeberName=sessionStorage.getItem("memeberName");
    },
    getOrganName(state){
      state.organName=sessionStorage.getItem("organName");
    },
    getSiteId(state){
      state.SiteId=sessionStorage.getItem("siteId");
    },
    getADId(state){
      state.getADId=sessionStorage.getItem("getADId");
    },
    getsiteInfo(state){
      state.siteInfo=JSON.parse(sessionStorage.getItem("siteInfo"));
    },
    getlightboxInfo(state){
      state.lightboxInfo=JSON.parse(sessionStorage.getItem("lightboxInfo"));
    }
  }
})
